import { Typography } from '@/components';
import type { FC, ReactNode } from 'react';

type Props = {
  list: ReactNode[];
  ellipsis?: boolean;
};

const ListItem = ({ children }: { children: string | ReactNode }) => {
  return (
    <li
      style={{
        listStyleType: 'disc',
        fontSize: 10, // for the size of '::marker'
        paddingInline: 0,
      }}
    >
      {children}
    </li>
  );
};

export const BulletPointsList: FC<Props> = ({ list, ellipsis = false }) => {
  return (
    <Typography.Paragraph style={{ marginBottom: 0 }} ellipsis={ellipsis}>
      <ul style={{ marginBottom: 0 }}>
        {list.map((item, index) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: biomeをCIに仕込むために暫定的にignore。keyにユニークな値を指定するか適切な理由に書き換えること
          <ListItem key={index}>{item}</ListItem>
        ))}
      </ul>
    </Typography.Paragraph>
  );
};
